import { createApi } from "@reduxjs/toolkit/query/react";
import { CONFIG_VARS } from "../../constants/urlConstants/configuration";
import { createBaseQuery } from "../../shared/utils/baseQuery";

const { inmobiusJobBaseUrl, inmobiusJobApiVersion } = CONFIG_VARS;

export const uploadMutation = createApi({
  reducerPath: "uploadMutation",
  baseQuery: createBaseQuery(inmobiusJobBaseUrl["1"], true), // Enable auth token
  endpoints: (builder) => ({
    bulkRegister: builder.mutation({
      query: ({ schoolId, formData }) => ({
        url: `${inmobiusJobApiVersion}/data-imports/bulk-register`,
        method: "POST",
        params: {
          school_id: schoolId,
        },
        body: formData,
        headers: {
          "product-id": "100",
        },
      }),
    }),
    bulkUpdate: builder.mutation({
      query: ({ schoolId, formData }) => ({
        url: `${inmobiusJobApiVersion}/data-imports/bulk-update`,
        method: "POST",
        params: {
          school_id: schoolId,
        },
        body: formData,
        headers: {
          "product-id": "1000",
        },
      }),
    }),
    getBulkRecordStatus: builder.query({
      query: (jobId) => ({
        url: `${inmobiusJobApiVersion}/data-imports/get-bulk-record-status`,
        method: "GET",
        params: {
          job_id: jobId,
        },
        headers: {
          "product-id": "1000",
        },
      }),
    }),
    getOfflineUploadStatus: builder.query({
      query: (jobId) => ({
        url: `${inmobiusJobApiVersion}/data-imports/get-offline-upload-status`,
        method: "GET",
        params: {
          job_id: jobId,
        },
        headers: {
          "product-id": "100",
          "tenant-id": "99999",
        },
      }),
    }),
    bulkEventReschedule: builder.mutation({
      query: ({ schoolId, uploadedBy, formData }) => ({
        url: `${inmobiusJobApiVersion}/data-imports/reschedule-events/`,
        method: "POST",
        params: {
          school_id: schoolId,
          uploaded_by: uploadedBy,
        },
        body: formData,
      }),
    }),
    bulkUploadOfflineResponses: builder.mutation({
      query: ({ schoolId, formData }) => ({
        url: `${inmobiusJobApiVersion}/data-imports/upload-offline-solutions`,
        method: "POST",
        params: {
          school_id: schoolId,
        },
        body: formData,
      }),
    }),
  }),
});

export const {
  useBulkRegisterMutation,
  useBulkUpdateMutation,
  useGetBulkRecordStatusQuery,
  useBulkEventRescheduleMutation,
  useBulkUploadOfflineResponsesMutation,
  useGetOfflineUploadStatusQuery,
} = uploadMutation;
